import { FavoritesHeartIconButton } from '@ori/favorites-heart';
import useTestId from '@ori/testid-generator';
import { FAVORITE } from "../../constants";
import { useTranslations } from "../../context";
import { jsx as _jsx } from "react/jsx-runtime";
export var Favorites = function Favorites(_ref) {
  var analyticsData = _ref.analyticsData,
    code = _ref.code,
    onFavoritesButtonClick = _ref.onFavoritesButtonClick,
    shades = _ref.shades;
  var _useTranslations = useTranslations(),
    favorites = _useTranslations.favorites;
  var _useTestId = useTestId(),
    getTestId = _useTestId.getTestId;
  return /*#__PURE__*/_jsx(FavoritesHeartIconButton, {
    smallerOnMobile: true,
    "aria-label": favorites,
    code: code,
    "data-testid": "".concat(getTestId(FAVORITE), "-").concat(code),
    placement: analyticsData === null || analyticsData === void 0 ? void 0 : analyticsData.placement,
    position: analyticsData === null || analyticsData === void 0 ? void 0 : analyticsData.position,
    shades: shades,
    onClick: onFavoritesButtonClick
  });
};
export default Favorites;
//# sourceMappingURL=Favorites.js.map